import Keycloak from 'keycloak-js';
const KEYCLOAK_REDIRECT = process.env.REACT_APP_KEYCLOAK_REDIRECT || 'http://192.168.1.20:3000';
const REACT_APP_KEYCLOAK_URL = process.env.REACT_APP_KEYCLOAK_URL || 'http://192.168.1.20:8082'

// Create the Keycloak instance
let keycloak;

export const initKeycloak = async () => {
  if (!keycloak) {
    keycloak = new Keycloak({
      url: REACT_APP_KEYCLOAK_URL, // Replace with your Keycloak server URL
      realm: 'qr-realm',                   // Replace with your Keycloak realm
      clientId: 'qr-frontend',         // Replace with your Keycloak client ID
    });

    // Initialize Keycloak


 await keycloak.init({
      onLoad: 'check-sso',  // Checks for an existing session
      silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
      pkceMethod: 'S256',
      checkLoginIframe: false,  // Disable the login iframe check (useful in some environments like Safari)
    });


    /*
    await keycloak.init({
      onLoad: 'check-sso',  // Checks for an existing session
      pkceMethod: 'S256',
      checkLoginIframe: false,  // Disable the login iframe check (useful in some environments like Safari)
      redirectUri: window.location.origin , 
      responseMode: 'query',
    });
    */
  }

  return keycloak;
};

export const getKeycloakInstance = () => keycloak;
